<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <nav class="breadcrumb" aria-label="Навигация">
    <ol class="breadcrumb__list">
      <li v-for="(item, index) in items" :key="index" class="breadcrumb__item">
        <NuxtLink
          v-if="item.href && index < items.length - 1"
          :to="item.href"
          class="breadcrumb__link"
        >
          {{ item.text }}
        </NuxtLink>
        <span v-else class="breadcrumb__current">
          {{ item.text }}
        </span>
        <span
          v-if="index < items.length - 1"
          class="breadcrumb__separator"
          aria-hidden="true"
        >
          /
        </span>
      </li>
    </ol>
  </nav>
</template>

<style lang="postcss" scoped>
.breadcrumb {
  margin-bottom: 8px;

  &__list {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 20px;
    padding: 0;
    list-style: none;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    line-height: 16px;
  }

  &__link {
    color: rgba(var(--text-dark-color--rgb), 60%);
    text-decoration: none;
    transition: var(--default-transition);

    &:hover {
      color: var(--accent-color);
    }
  }

  &__current {
    color: rgba(var(--text-dark-color--rgb), 40%);
    font-weight: 500;
  }

  &__separator {
    color: rgba(var(--text-dark-color--rgb), 30%);
    font-size: 10px;
  }
}
</style>
